
import Vue, {PropOptions} from 'vue'
import {OrderInterface} from "~/store/order";
import {PaymentInterface} from '~/store/payment';

export default Vue.extend({
  name: 'paymentOptions',
  props: {
    order: {
      type: Object,
      required: true
    } as PropOptions<OrderInterface>
  },
  data(): { checkedPaymentOption: string, payment: PaymentInterface | null, loading: boolean } {
    return {
      checkedPaymentOption: 'complete',
      payment: null,
      loading: false,
    }
  },
  methods: {
    setSelectedPaymentOption(paymentOption: string) {
      this.checkedPaymentOption = paymentOption
    },
    async pay() {
      const id = this.$route.params.id
      const key = this.$route.query.key

      this.loading = true;


      // this.payment = await this.$axios.$post<{ data: PaymentInterface }>(`/v1/order/payment-option/${this.checkedPaymentOption}/${id}/${key}`).then(data => data.data);
      this.payment = await this.$axios.$post<{ data: PaymentInterface }>(`https://butler.chefstbl.com/api/marketplace/v1/order/payment-option/${this.checkedPaymentOption}/${id}/${key}`).then(data => data.data);
      if (this.payment) {
        window.location.href = this.payment.checkout_url;
      }
    }
  }
})
